import * as React from "react";
import { forwardRef } from "react";
const SvgToolAngle = ({
  title,
  titleId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd" strokeLinecap="round" strokeWidth={1.5}><path d="M21 3L12.6429 11.2895M20.5714 21H15.8571M12.6429 11.2895L3 21H15.8571M12.6429 11.2895C16.8338 13.551 17.4665 15.7102 15.8571 21" stroke="#CCCCCC" strokeWidth={2} strokeLinecap="round" /></g></svg>;
const ForwardRef = forwardRef(SvgToolAngle);
export { ForwardRef as ReactComponent };